import { useState } from "react";

import { IntroUIComponent } from "../../components/IntroUIComponent";

/**
 * This component only dictates how long the intro screen should be visible,
 * in case we want to show something but the app loads faster than the content
 * @param props
 * @returns
 */
export function ProjectIntroComponent(props: any) {
  const [enabled, setEnabled] = useState(false);

  const endIntroScreen = setTimeout(() => {
    setEnabled(true);
  }, 8000);

  return (
    <>
      {!enabled && (
        <IntroUIComponent
          {...props}
          setEnabled={setEnabled}
          endIntroScreen={endIntroScreen}
        />
      )}
      {enabled && props.children}
    </>
  );
}
